import { ControlValveAnimatic } from '@crossnokaye/ux-animatics';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticControlValve = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const kind = config.specificAnimaticConfig?.controlValve?.kind;
  const valueRef = config.specificAnimaticConfig?.controlValve?.valueRef;
  const value = valueRef ? convertPercentToDecimal(getRefValue(valueRef)) : undefined;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={0.98} scaleY={0.98}>
      <ControlValveAnimatic
        label={primaryLabel?.text}
        state={state}
        type={kind as 'motorized' | 'icad' | 'pneumatic' | 'king'}
        value={value}
      />
    </ScaledAnimatic>
  );
};
